import { useContext, useEffect, useState } from "react";
import { ApiContext } from "../context/ApiContext";
import endpoints from "../data/endpoints";
import getStepData from "../requests/getStepData";
import { getQuery } from "../requests/queries";
import { StepIndex } from "../types/types";

const useStepData = (stepNo: StepIndex) => {
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);
	const [stepData, setStepData] = useState(null);
	const { data, setData } = useContext(ApiContext);

	useEffect(() => {
		const endpoint = getEndpoint(stepNo, endpoints);
		const query = getQuery(stepNo, data);

		const getData = async () => {
			try {
				setLoading(true);
				const apiResponse = await getStepData(stepNo, endpoint, query);
				setData({
					...data,
					...apiResponse.data,
				});
				setStepData(apiResponse.data);
			} catch (error) {
				const message =
					error instanceof Error ? error.message : "Something went wrong";
				setError(message);
			} finally {
				setLoading(false);
			}
		};

		getData();
	}, [stepNo]); // eslint-disable-line react-hooks/exhaustive-deps

	const result: {
		error: string;
		loading: boolean;
		stepData: any;
	} = {
		error,
		loading,
		stepData,
	};

	return result;
};

const getEndpoint = (stepNo: StepIndex, endpoints: any) => {
	switch (stepNo) {
		case 0:
			return endpoints.step0;
		case 1:
			return endpoints.step1;
		case 2:
			return endpoints.step2;
		case 3:
			return endpoints.step3;
		case 4:
			return endpoints.step4;
		default:
			return "";
	}
};

export default useStepData;
